import { Component, Input, OnInit } from '@angular/core';
import {InvoiceDocFormat, Subscription} from '../subscription.model';
import { Model } from '../../app.model';
import { AutorunComponent } from '@myshared/autorun.component';
import { I18NextService } from 'angular-i18next';
import {SelectOption} from "../../forms/components/input-select";
import {SubscriptionService} from "../subscription.service";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'app-subscription-invoice-type-card',
    templateUrl: './subscription-invoice-type-card.component.html',
    standalone: false
})
export class SubscriptionInvoiceTypeCardComponent extends AutorunComponent implements OnInit {
  @Input() subscription: Subscription;

  public invoiceFormatForTranslation: string;
  public selectableTypes: SelectOption[] = [];
  public isEdit: boolean = false;
  public selectedFormat: InvoiceDocFormat;
  public invoiceDocFormat: InvoiceDocFormat;

  constructor(
    private m: Model,
    private i18next: I18NextService,
    private subscriptionService: SubscriptionService
  ) {
    super();
  }

  ngOnInit() {
    const invoiceFormats = this.m.account.currentUser.tenant.invoiceDocumentFormats;
    const translatedTypes: string[] = [];
    const subscriptionInvoiceFormat = this.subscription.invoiceDocFormat;
    this.selectedFormat = subscriptionInvoiceFormat; // The model value for the form
    this.invoiceDocFormat = subscriptionInvoiceFormat; // The actual value we need to change after saving it

    for (let format of invoiceFormats) {
      const translatedType = this.i18next.t(format) as string;
      this.selectableTypes.push({
        label: translatedType,
        value: format
      });
      translatedTypes.push(translatedType);
    }

    this.invoiceFormatForTranslation = translatedTypes.join(', ');
  }

  edit() {
    this.isEdit = true;
  }

  async save() {
    this.isEdit = false;
    try {
      await firstValueFrom(this.subscriptionService.putInvoiceFormat(this.subscription.appliance_id, this.selectedFormat));
      this.invoiceDocFormat = this.selectedFormat;
    } catch (e) {
      console.error(e);
    }
  }

  cancel() {
    this.isEdit = false;
    this.selectedFormat = this.subscription.invoiceDocFormat;
  }

  get canEdit() {
    if (this.m.account.currentUser.tenant.invoiceDocumentFormats.length === 1 && this.m.account.currentUser.tenant.invoiceDocumentFormats[0] === this.subscription.invoiceDocFormat) {
      return true;
    }

    return this.m.account.currentUser.tenant.invoiceDocumentFormats.length > 0;
  }
}
